<template>
  <div class="h-100 d-flex flex-column align-items-center justify-content-center">
    <button type="button" @click="buyCodeBtn()" class="btn btn-light btn-own mb-3 align-self-center ">
      Купить код активации
    </button>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'

// /api/side-pricing
export default {
  name: 'OrderVpnCode',
  data () {
    return {
      code: ''
    }
  },
  computed: {
    ...mapState('pricing', {
      orders: state => state.orders,
      invalidCode: state => state.invalidCode
    })
  },
  mounted () {
  },
  methods: {
    ...mapActions('pricing', {
      makeOrder: 'makeOrder',
      checkCode: 'checkCode',
      buyCode: 'buyCode'
    }),
    ...mapGetters('pricing', [
      'priceItems'
    ]),
    checkCodeBtn: function () {
      this.checkCode(this.code)
    },
    buyCodeBtn: function () {
      this.buyCode()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.code {
  border-radius: 15px;
  width: 315px;

}

input.invalid {
  border-color: red;
}
</style>
